import { FilterOperator, IDataType, IOperatorOption } from "../../../types/dataGrid";


// Centralized Operator Map
export const OPERATOR_MAP: Record<IDataType, IOperatorOption[]> = {
  string: [
    { label: "Equals", value: FilterOperator.Equal },
    { label: "Not Equals", value: FilterOperator.NotEqual },
    { label: "Contains", value: FilterOperator.Contains },
    { label: "Begins With", value: FilterOperator.BeginsWith },
    { label: "Ends With", value: FilterOperator.EndsWith },
  ],
  number: [
    { label: "Equals", value: FilterOperator.Equal },
    { label: "Not Equals", value: FilterOperator.NotEqual },
    { label: "Less Than", value: FilterOperator.Less },
    { label: "Less or Equal", value: FilterOperator.LessOrEqual },
    { label: "Greater Than", value: FilterOperator.Greater },
    { label: "Greater or Equal", value: FilterOperator.GreaterOrEqual },
    { label: "Between", value: FilterOperator.Between },
    { label: "Not Between", value: FilterOperator.NotBetween },
  ],
  date: [
    { label: "Equals", value: FilterOperator.Equal },
    { label: "Not Equals", value: FilterOperator.NotEqual },
    { label: "Before", value: FilterOperator.Less },
    { label: "Before or On", value: FilterOperator.LessOrEqual },
    { label: "After", value: FilterOperator.Greater },
    { label: "After or On", value: FilterOperator.GreaterOrEqual },
    { label: "Between", value: FilterOperator.Between },
    { label: "Not Between", value: FilterOperator.NotBetween },
  ],
  boolean: [
    { label: "Is", value: FilterOperator.Equal },
    { label: "Is Not", value: FilterOperator.NotEqual },
  ],
  dropdown: [
    { label: "Equals", value: FilterOperator.Equal },
    { label: "Not Equals", value: FilterOperator.NotEqual },
  ],
  time: [
    { label: "Equals", value: FilterOperator.Equal },
    { label: "Not Equals", value: FilterOperator.NotEqual },
    { label: "Before", value: FilterOperator.Less },
    { label: "Before or On", value: FilterOperator.LessOrEqual },
    { label: "After", value: FilterOperator.Greater },
    { label: "After or On", value: FilterOperator.GreaterOrEqual },
    { label: "Between", value: FilterOperator.Between },
    { label: "Not Between", value: FilterOperator.NotBetween },
  ],
};